import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-gray-50" }
const _hoisted_2 = { class: "prose px-6 py-5 text-sm text-gray-400" }
const _hoisted_3 = { class: "text-xl font-medium text-secondary [&>a]:no-underline [&>a]:text-secondary cursor-pointer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("u", null, "Indberetninger", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "dynamic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('/reports')))
          }, _hoisted_5),
          _createTextVNode(" / " + _toDisplayString(_ctx.reportTypeDisplay), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportDetailsComponents, (componentName) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(componentName), { key: componentName }))
      }), 128))
    ])
  ], 64))
}